<div class="wrapper selenium-filter-by-type">
    <ng-select
        [items]="mediaTypes"
        [multiple]="false"
        dropdownPosition="bottom"
        [hideSelected]="true"
        [searchable]="false"
        [clearable]="false"
        [markFirst]="true"
        placeholder="Type"
        [(ngModel)]="selectedType"
        (change)="changeType($event, selectedType)"
        class="dropdown"
    >
    </ng-select>
</div>
